/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const FavoriteFill: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M13.112 3.82584C12.7455 2.72471 11.2545 2.72472 10.888 3.82584L9.22359 8.82655L4.1554 8.93442C3.03941 8.95817 2.57865 10.4392 3.46813 11.1435L7.50767 14.342L6.03974 19.4093C5.71651 20.5251 6.92283 21.4405 7.83904 20.7746L12 17.7507L16.161 20.7746C17.0772 21.4405 18.2835 20.5251 17.9603 19.4093L16.4923 14.342L20.5319 11.1435C21.4214 10.4392 20.9606 8.95817 19.8446 8.93442L14.7764 8.82655L13.112 3.82584Z'
      fill='currentColor'
    />
  </React.Fragment>
)
